import { Routes } from '@angular/router';
import { APP_PATHS } from '../../shared/constants/routes.constants';

export const authRoutes: Routes = [
  {
    path: APP_PATHS.AUTH,
    loadComponent: () => import('./auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: APP_PATHS.LOGIN,
        pathMatch: 'full',
      },
      {
        path: APP_PATHS.LOGIN,
        loadComponent: () => import('./log-in/log-in.component').then((m) => m.LogInComponent),
      },
      {
        path: APP_PATHS.SIGNUP,
        loadComponent: () => import('./sign-up/sign-up.component').then((m) => m.SignUpComponent),
      },
    ],
  },
];
